<template>
    <div class="main-content">
        <div class="container">
            <h1>Copyrighted by Rusiann</h1>
            <h2>Other codes used in this project, go to their respective creators. Thanks</h2>
            <p>Special thanks to the A.I. that debugged this entire codebase of a mess and shout out to the school.</p>
            <div class="image-row">
  <img src="@/assets/overlay1.png" alt="yes" style="max-width: 350px; width: 100%; height: auto;">
</div>
        </div>
    </div>

</template>

<script>

export default {
    name: 'yesSirr',
    data() {
        return {
            
        };
    },
    methods: {
       
    },
};

</script>

<style scoped>

.main-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.image-row {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
}

.image-row img {
    max-width: 400px;
    width: 100%;
    height: auto;
}

</style>